import React from 'react';
import { ErrorMessage, Grid, Notification } from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { IVendorPayoffInformationData } from '../../../types/vendorDashboard/IVendorPayoffInformation';
import { IStandardDocumentVersionData } from '../../../types/order/documents/shared/interfaces';
import { OrderPanel } from '../../../components/vendorDashboard/OrderPanel';
import { OrderDetails } from '../../../components/vendorDashboard/OrderDetails';
import { Comments } from '../../../components/vendorDashboard/comments/Comments';
import { DocumentBlock } from '../../../components/vendorDashboard/DocumentBlock';
import { SearchReportBlock } from '../../../components/vendorDashboard/SearchReportBlock';
import { ClientUrlFactory } from '../../../ui-toolkit/rest/ClientUrlFactory';
import { buildIsVendorPayoffByName, IDocumentCategory } from '../../../types/order/documents/IDocumentCategoryType';
import { UUID } from '../../../types/shared/UUID';
import { PayoffStatusAndETA } from '../../../components/vendorDashboard/payoffs/PayoffStatusAndETA';
import { eVendorServiceType } from '../../../types/order/title/eVendorServiceType';
import {
  defaultNormalizedDocumentCategoriesData,
  useListDocumentCategoriesQuery,
} from '../../../API/documentCategories/DocumentCategoriesApi';

export interface IVendorPayoffPageProps {
  orderId: UUID;
  payoff: IVendorPayoffInformationData;
  documents: IStandardDocumentVersionData[];
  pageError?: string;
  uploadNewCommentFetch: IFetchStatus;
  onSendToSpruce: () => void;
  sendToSpruceFetchStatus: IFetchStatus;
  sendToSpruceError?: string;
}

export const VendorPayoffPage: React.FC<IVendorPayoffPageProps> = ({
  orderId,
  payoff,
  pageError,
  documents,
  onSendToSpruce,
  sendToSpruceFetchStatus,
  sendToSpruceError,
}) => {
  const documentCategoryFilter = (doc: IDocumentCategory) => {
    return doc.isVendorPayoff;
  };

  const { data: { allCategories, documentCategoriesByName } = defaultNormalizedDocumentCategoriesData } =
    useListDocumentCategoriesQuery();

  const isVendorPayoffByName = buildIsVendorPayoffByName(documentCategoriesByName);
  const readyToSend = documents.some((document) => isVendorPayoffByName(document.category));

  return (
    <>
      <OrderPanel
        prefix={'Payoff'}
        backTo={ClientUrlFactory().urlFor.vendorPayoffs()}
        fileNumber={payoff.fileNumber}
        createdAt={payoff.timeEnteredQueue}
        readyToSend={readyToSend}
        onSendToSpruce={onSendToSpruce}
        status={payoff.status}
        sendToSpruceFetchStatus={sendToSpruceFetchStatus}
      />
      {pageError && <ErrorMessage message={pageError} />}
      {sendToSpruceFetchStatus.success && !sendToSpruceError && (
        <Notification type={'success'} message={'Thank you! Spruce has been notified.'} />
      )}
      <Grid columnCount={3}>
        <OrderDetails order={payoff} />
        <PayoffStatusAndETA orderId={orderId} payoff={payoff} />
        <Comments orderId={orderId} vendorServiceType={eVendorServiceType.payoffRequest} />
      </Grid>
      <DocumentBlock
        documents={documents}
        documentCategoriesByName={documentCategoriesByName}
        documentCategories={allCategories}
        documentCategoryFilter={documentCategoryFilter}
        orderId={orderId}
      />
      <SearchReportBlock orderId={payoff.orderId} />
    </>
  );
};
